export enum DirectOutputTapPoint {
	PreProcessingPreGate = 'PRE_PROCESSING_PRE_GATE',
	PostProcessingPreGate = 'POST_PROCESSING_PRE_GATE',
	PreProcessingPostGate = 'PRE_PROCESSING_POST_GATE',
	PostProcessingPostGate = 'POST_PROCESSING_POST_GATE'
}
